<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]">
    <vx-sidebar
      :sidebarItems="sidebarItems"
      :logo="logo"
      title="Portal"
      parent=".layout--main"
    />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar
          :navbarColor="navbarColor"
          :clanName="this.clan.name"
          :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]"
        />

        <div class="router-view">
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
            <transition :name="routerTransition">
              <div
                class="router-header flex flex-wrap items-center mb-6"
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
              >
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb"/>
                <!-- <vs-dropdown class="ml-auto md:block hidden" vs-trigger-click>
                  <vs-button radius icon="icon-settings" icon-pack="feather"></vs-button>

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <router-link to="/pages/profile" class="flex items-center">
                        <feather-icon
                          icon="UserIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Profile</span>
                      </router-link>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <router-link to="/apps/todo" class="flex items-center">
                        <feather-icon
                          icon="CheckSquareIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Tasks</span>
                      </router-link>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <router-link to="/apps/email" class="flex items-center">
                        <feather-icon
                          icon="MailIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Inbox</span>
                      </router-link>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown> -->
              </div>
            </transition>
            <div class="content-area__content">
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from "@/layouts/components/vx-sidebar/VxSidebar.vue";
import TheNavbar from "../components/TheNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import sidebarItems from "@/layouts/components/vx-sidebar/sidebarItems.js";
import { mapState } from "vuex";

import { getGameProfile } from "../../_services/gameProfile.service.js";
import { getFormations } from "../../_services/formations.service.js";

export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || "floating",
      navbarColor: themeConfig.navbarColor || "#fff",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      clan: {},
      logo: ''
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      if (this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    }
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating"
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    async updateNavbarItems() {
      const defaultDomains = ['pzgame.localhost', 'portalgame.escolazion.com']
      const domain = window.location.host.split(':')[0]
      if (defaultDomains.includes(domain))  {
        this.sidebarItems.push({
          url: "/quests",
          name: "Quests",
          slug: "quests",
          icon: "PocketIcon",
        })
        this.logo = require('@/assets/images/logo/zicone.png')
      } else {
        this.logo = require('@/assets/images/logo/zgeek-logo.png')
      }

      let formations = await getFormations({
        studentId: this.account.user.student.id
      });
      let formationItems = []
      for (let formation of formations) {
        let moduleGroups = []
        for(let moduleGroup of formation.moduleGroups) {
          moduleGroups.push({
            url: "/module-group/"+ moduleGroup.id,
            name: moduleGroup.nome,
            slug: moduleGroup.nome
          })
        }
        formationItems.push({
          name: formation.nome,
          slug: formation.nome,
          submenu: moduleGroups
        })
      }
      this.sidebarItems.push({
        url: "/",
        name: "Formação",
        slug: "home",
        icon: "HomeIcon",
        submenu: formationItems
      })
      
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    updateThemeColor() {
      const geekDomains = ['pzgeek.localhost', 'portalgame.ziongeek.com']
      const domain = window.location.host.split(':')[0]
      if (geekDomains.includes(domain)) {
        if (document.body.className.match('portal-default')) document.body.classList.remove('portal-default');
        document.body.classList.add('portal-geek');

        this.$vs.theme({ primary: '#512467' });
        this.$store.commit("UPDATE_PRIMARY_COLOR", '#512467');
      }
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    async updateClan() {
      let gameProfile = await getGameProfile({
        studentId: this.account.user.student.id
      });
      this.$store.commit("UPDATE_GAME_PROFILE", gameProfile);
      this.clan = gameProfile.clan;
      this.$vs.theme({ primary: this.clan.color });
      this.$store.commit("UPDATE_PRIMARY_COLOR", this.clan.color);
      this.updateNavbarColor(this.clan.color);
    }
  },
  created() {
    this.updateThemeColor();
    this.setSidebarWidth();
    if (this.navbarColor == "#fff" && this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
    this.updateNavbarItems();
    this.updateClan();
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter
  }
};
</script>
<style>
.portal-geek .main-menu-sidebar .vs-sidebar {
  background-color: #512467 !important;
}
.portal-geek .main-menu-sidebar .header-sidebar .logo .logo-text {
  color: #fff;
}
</style>